import type { Locale, LocaleConfig, SyntheticLocale } from "../types";

export const restrictedCryptoLocale = "en-GB";
export const syntheticLocales: SyntheticLocale[] = ["en-without-crypto"];
export const hiddenLocales: Locale[] = ["ru"];
export const locales: Locale[] = [
  "en",
  "de",
  "fr",
  "es",
  "tr",
  "ja",
  "zh-Hans",
  "ko",
  "en-GB",
]; // влияет на роут

export const CRYPTO_ACTIVE_LOCALES: Locale[] = locales.filter((locale) => locale !== restrictedCryptoLocale);
export const defaultLocale: Locale = "en";

export const localeVarName: string = "locale";

export const localeConfig: { [key in Locale]: LocaleConfig } = {
  en: {
    languageName: "English",
    currency: "USD",
    fractionDigits: 2,
    locale: "en-US",
    paymentMethods: ["paypal"],
    deliveryCost: 100,
    group: "int",
    products: {
      variants: ["TG128X3-B", "TG128X2-B"],
    },
  },
  "en-GB": {
    languageName: "English UK",
    currency: "USD",
    fractionDigits: 2,
    locale: "en-GB",
    paymentMethods: ["paypal"],
    deliveryCost: 100,
    group: "int",
    products: {
      variants: ["TG128X3-B", "TG128X2-B"],
    },
  },
  de: {
    languageName: "Deutsch",
    currency: "USD",
    fractionDigits: 2,
    locale: "de-DE",
    paymentMethods: ["paypal"],
    products: {
      variants: ["TG128X3-B", "TG128X2-B"],
    },
    deliveryCost: 100,
    group: "int",
  },
  ru: {
    languageName: "Русский",
    currency: "RUB",
    fractionDigits: 0,
    locale: "ru-RU",
    paymentMethods: ["insales"],
    group: "ru",
    products: {
      variants: ["TG130X3-B", "TG130X2-B"],
    },
  },
  fr: {
    languageName: "Français",
    currency: "USD",
    fractionDigits: 2,
    locale: "fr-FR",
    paymentMethods: ["paypal"],
    products: {
      variants: ["TG128X3-B", "TG128X2-B"],
    },
    deliveryCost: 100,
    group: "int",
  },
  es: {
    languageName: "Español",
    currency: "USD",
    fractionDigits: 2,
    locale: "es-ES",
    paymentMethods: ["paypal"],
    products: {
      variants: ["TG128X3-B", "TG128X2-B"],
    },
    deliveryCost: 100,
    group: "int",
  },
  tr: {
    languageName: "Türkçe",
    currency: "USD",
    fractionDigits: 2,
    locale: "tr-TR",
    paymentMethods: ["paypal"],
    products: {
      variants: ["TG128X3-B", "TG128X2-B"],
    },
    deliveryCost: 100,
    group: "int",
  },

  ko: {
    languageName: "한국어",
    currency: "USD",
    fractionDigits: 2,
    locale: "ko",
    paymentMethods: ["paypal"],
    products: {
      variants: ["TG128X3-B", "TG128X2-B"],
    },
    deliveryCost: 100,
    group: "int",
  },

  ja: {
    languageName: "日本語",
    currency: "USD",
    fractionDigits: 2,
    locale: "ja-JP",
    paymentMethods: ["paypal"],
    products: {
      variants: ["TG128X3-B", "TG128X2-B"],
    },
    deliveryCost: 100,
    group: "int",
  },
  "zh-Hans": {
    languageName: "中文",
    currency: "USD",
    fractionDigits: 2,
    locale: "zh-TW",
    paymentMethods: [ "paypal"],
    products: {
      variants: ["TG128X3-B", "TG128X2-B"],
    },
    deliveryCost: 100,
    group: "int",
  },
};
